import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BackgroundContainerStyled from '../lib/styledcomponents/layout/BackgroundContainerStyled';
import MagicHat from '../img/MagicHat.svg';

const StackContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  maxWidth: theme.breakpoints.values.xs,
}));

const TypographyStyled = styled(Typography)(({ theme }) => ({
  textAlign: `center`,
  paddingLeft: `${theme.sizing.mdPadding}px`,
  paddingRight: `${theme.sizing.mdPadding}px`,
  whiteSpace: 'pre-wrap',
}));

export default function StartPhase2() {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <BackgroundContainerStyled    
      direction="column"
      alignItems="center"
    >
      <StackContainer spacing={8}>
        <Stack sx={{ alignItems: 'center' }} spacing={2}>
          <TypographyStyled
            variant="h0"
          >
            {t('gameinprogress.startphase2.title')}
          </TypographyStyled>
          <TypographyStyled
            variant="textLabel"
            sx={{
              color: `${theme.palette.primary.main}`,
            }}
          >
            {t('gameinprogress.startphase2.subtitle1')}
          </TypographyStyled>
        </Stack>
        <img
          style={{
            width: '214px',
            height: '118px',
          }}
          src={MagicHat}
          alt="Question"
        />
        <TypographyStyled variant="h3">
          {t('gameinprogress.startphase2.subtitle2')}
        </TypographyStyled>
      </StackContainer>
    </BackgroundContainerStyled>
  );
}
